import { IonicModule } from 'ionic-angular';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';  
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule],
  exports: [CommonModule, FormsModule,IonicModule],
  declarations: [

  ]
})
export class SharedModule { }  


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts